/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PriceUpdateDto } from '../../models/price-update-dto';

export interface PricesControllerUpdatePrice$Params {
  priceId: string;
      body: PriceUpdateDto
}

export function pricesControllerUpdatePrice(http: HttpClient, rootUrl: string, params: PricesControllerUpdatePrice$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, pricesControllerUpdatePrice.PATH, 'put');
  if (params) {
    rb.path('priceId', params.priceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

pricesControllerUpdatePrice.PATH = '/keus-payments/prices/{priceId}';
